import { escapeRegExp } from "./escapeRegExp"

export const abbrValue = (value, decimalSeparator = ".", _decimalPlaces = 10) => {
  if (value > 999) {
    let valueLength = ("" + value).length
    const p = Math.pow
    const d = p(10, _decimalPlaces)
    valueLength -= valueLength % 3

    const abbrValue = Math.round((value * d) / p(10, valueLength)) / d + " kMGTPE"[valueLength / 3]
    return abbrValue.replace(".", decimalSeparator)
  }

  return String(value)
}

const abbrMap = { k: 1000, m: 1000000, b: 1000000000 }

export const parseAbbrValue = (value, decimalSeparator = ".") => {
  const reg = new RegExp(`(\\d+(${escapeRegExp(decimalSeparator)}\\d*)?)([kmb])$`, "i")
  const match = value.match(reg)

  if (match) {
    const [, digits, , abbr] = match
    const multiplier = abbrMap[abbr.toLowerCase()]

    return Number(digits.replace(decimalSeparator, ".")) * multiplier
  }

  return undefined
}
